import * as types from '../actions/types';
import mapKeys from 'lodash/mapKeys';

const INITIAL_STATE = {
  messages: [],
  messagesAsObject: {},
  reciever: '',
  onProgress: '',
  completed: '',
  error: {
    type: '',
    message: '',
  },
};

const chatReducer = (state = INITIAL_STATE, { payload, type, error }) => {
  // store cities used in signup
  switch (type) {
    case types.FETCH_MESSAGES_HISTORY_REQUEST:
      return {
        ...state,
        onProgress: 'FETCH_MESSAGES',
        completed: '',
      };
    case types.FETCH_MESSAGES_HISTORY_SUCCESS: {
      const reciever = payload.messages.find(
        (msg) =>
          msg?.entry?.user?._id !== payload.currentUserId && !msg?.entry.system
      );

      const messages = mapKeys(payload.messages, 'entry._id');

      return {
        ...state,
        onProgress: '',
        completed: 'FETCH_MESSAGES',
        messages: payload.messages,
        messagesAsObject: messages,
        reciever: reciever?.entry?.user?.name,
      };
    }
    case types.FETCH_MESSAGES_HISTORY_FAIL:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {
          type: 'FETCH_MESSAGES',
          message: error.message,
        },
      };

    case 'pubnub/MESSAGE_RECEIVED': {
      const entry = {
        entry: payload.message,
      };

      let messages = state.messagesAsObject;
      messages[payload.message._id] = entry;

      return {
        ...state,
        onProgress: '',
        completed: '',
        messages: Object.values(messages),
      };
    }

    default:
      return { ...state };
  }
};

export default chatReducer;
